// extracted by mini-css-extract-plugin
export default {"manageModalContainer":"PersonalisedMenteeEmailersAddModal_manageModalContainer__tFy5y"};